export const MALLIGYOUNG_DESCRIPTIONS = {
  title: "Malligyong Tracker",
  subtitle: "Malligyong-1/58400/2023-179A",
  content: `Malligyong-1 (meaning Telescope-1) is a North Korean reconnaissance
  satellite. It is North Korea's first spy satellite launched on 21
  November 2023. It is in a sun-synchronous orbit at about 500
  kilometers (310mi) altitude and will provide a global optical imaging
  surveillance capability principally for South Korea, Japan, and the
  U.S. It orbits the earth approximately 15 times everyday and passes by
  major sites in the Korean Peninsula everyday.`
};

export const NURI_DESCRIPTIONS = {
  title: "Nuri Tracker",
  subtitle: "KSLV II",
  content: `Nuri (Korean: 누리; meaning "world"), also known as KSLV II (Korean
    Space Launch Vehicle-II), is a three-stage launch vehicle, the second
    one developed by South Korea and the successor to Naro-1 (KLSV-1).
    Nuri is developed by the Korea Aerospace Research Institute (KARI).
    All three stages use indigenously developed launch vehicle engines,
    making Nuri the first indigenously developed South Korean orbital
    launch vehicle. As a result of this launch, South Korea became the
    seventh country in the world with the ability to put a satellite with
    a mass of at least one ton, into orbit. After the two test launches,
    Nuri showed higher-than-expected performance, increasing its payload
    from 1,500 kg (3,300lb) to 1,900kg (4200lb).`
};

export const NTU_SAT_DESCRIPTIONS = {
  title: "NTU-SAT Tracker",
  subtitle: "NTU-SAT",
  content: `NTU-SAT (Korean: 누리; meaning "world"), also known as KSLV II (Korean
    Space Launch Vehicle-II), is a three-stage launch vehicle, the second
    one developed by South Korea and the successor to Naro-1 (KLSV-1).
    Nuri is developed by the Korea Aerospace Research Institute (KARI).
    All three stages use indigenously developed launch vehicle engines,
    making Nuri the first indigenously developed South Korean orbital
    launch vehicle. As a result of this launch, South Korea became the
    seventh country in the world with the ability to put a satellite with
    a mass of at least one ton, into orbit. After the two test launches,
    Nuri showed higher-than-expected performance, increasing its payload
    from 1,500 kg (3,300lb) to 1,900kg (4200lb).`
};

export const KDIC_SAT_DESCRIPTIONS = {
  title: "KDIC-STM",
  subtitle: "KDIC-STM",
  content: `KDIC-STM (Korean: 누리; meaning "world"), also known as KSLV II (Korean
    Space Launch Vehicle-II), is a three-stage launch vehicle, the second
    one developed by South Korea and the successor to Naro-1 (KLSV-1).
    Nuri is developed by the Korea Aerospace Research Institute (KARI).
    All three stages use indigenously developed launch vehicle engines,
    making Nuri the first indigenously developed South Korean orbital
    launch vehicle. As a result of this launch, South Korea became the
    seventh country in the world with the ability to put a satellite with
    a mass of at least one ton, into orbit. After the two test launches,
    Nuri showed higher-than-expected performance, increasing its payload
    from 1,500 kg (3,300lb) to 1,900kg (4200lb).`
};

export const MALAY_SAT_DESCRIPTIONS = {
  title: "Malay-SAT",
  subtitle: "Malay-SAT",
  content: `Malay-SAT (Korean: 누리; meaning "world"), also known as KSLV II (Korean
    Space Launch Vehicle-II), is a three-stage launch vehicle, the second
    one developed by South Korea and the successor to Naro-1 (KLSV-1).
    Nuri is developed by the Korea Aerospace Research Institute (KARI).
    All three stages use indigenously developed launch vehicle engines,
    making Nuri the first indigenously developed South Korean orbital
    launch vehicle. As a result of this launch, South Korea became the
    seventh country in the world with the ability to put a satellite with
    a mass of at least one ton, into orbit. After the two test launches,
    Nuri showed higher-than-expected performance, increasing its payload
    from 1,500 kg (3,300lb) to 1,900kg (4200lb).`
};

export const DATA_INFO = {
  MALLIGYOUNG: {
    siteDescription:
      "This site shows the current state of Malligyong satellite.",
    dataInfo: {
      "Orbit data": "TLE",
      "FoV assumption":
        "90 degrees\n(reference data : Arirang Satellite Mounted Camera)",
      "Sampling rate": "1 Hz",
      "Prediction period": "3 days",
      "Time unit": "Korea Standard Time (KST)",
      "Update cycle": "8 hours",
      "Ground Access": "City entering Malligyong's visibility cone",
      "Contain Relation": "Malligyong entering OOI's visibility cone"
    }
  },
  NURI: {
    siteDescription: "This site shows the current state of Nuri satellite.",
    dataInfo: {
      "Orbit data": "TLE",
      "Sampling rate": "1 Hz",
      "Prediction period": "3 days",
      "Time unit": "Korea Standard Time (KST)",
      "Update cycle": "8 hours"
    }
  },
  NTU_SAT: {
    siteDescription: "This site shows the current state of NTU-SAT satellite.",
    dataInfo: {
      "Orbit data": "TLE",
      "Sampling rate": "1 Hz",
      "Prediction period": "3 days",
      "Time unit": "Universal Time Coordinated (UTC)",
      "Update cycle": "8 hours"
    }
  },
  KDIC_SAT: {
    siteDescription: "This site shows the current state of KDIC-STM satellite.",
    dataInfo: {
      "Orbit data": "TLE",
      "Sampling rate": "1 Hz",
      "Prediction period": "3 days",
      "Time unit": "Universal Time Coordinated (UTC)",
      "Update cycle": "8 hours"
    } 
  },
  MALAY_SAT: {
    siteDescription: "This site shows the current state of Malay SAT satellite.",
    dataInfo: {
      "Orbit data": "TLE",
      "Sampling rate": "1 Hz",
      "Prediction period": "3 days",
      "Time unit": "Universal Time Coordinated (UTC)",
      "Update cycle": "8 hours"
    }
  }
};
